<template>
  <div class="app-list-page">
    <tableComponents
      :pagination="{
        currentPage: paginationForm.page,
        pageSize: paginationForm.page_size,
        total,
      }"
      :searchData="appSearchData"
      :isHaveExport="false"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      @sendUserSearch="getSearch"
      @toAdd="openEditor()"
    >
      <template #table>
        <el-table :data="list" border stripe v-loading="loading">
          <el-table-column prop="id" label="ID" width="70" align="center" />
          <el-table-column label="应用名称" min-width="180">
            <template slot-scope="{ row }">
              <div class="app-main">
                <div class="app-main__title">
                  {{ row.app_name || row.app_code }}
                </div>
                <div class="app-main__sub">{{ row.app_code || "--" }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="package_name" label="包名" min-width="220" />
          <el-table-column label="马甲包广告" width="140" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="Number(getVestPackageStatus(row)) === 1 ? 'success' : 'info'">
                {{ Number(getVestPackageStatus(row)) === 1 ? "开启" : "关闭" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Bootstrap" min-width="220">
            <template slot-scope="{ row }">
              <div class="bootstrap-summary">
                <el-tag
                  size="mini"
                  :type="Number(row.bootstrap_sdk_enabled) === 1 ? 'success' : 'info'"
                >
                  {{ Number(row.bootstrap_sdk_enabled) === 1 ? "SDK开启" : "SDK未配" }}
                </el-tag>
                <div class="bootstrap-summary__sub">
                  {{ row.bootstrap_version_tag || "--" }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="Number(row.status) === 1 ? 'success' : 'info'">
                {{ Number(row.status) === 1 ? "启用" : "禁用" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="160" align="center">
            <template slot-scope="{ row }">
              {{ $fnc.getTimeFormat(row.created_time, "ymdhms") }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="360"
            align="center"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <el-button
                size="mini"
                type="primary"
                plain
                @click="goDetail(row.id)"
              >
                详情
              </el-button>
              <el-button
                size="mini"
                type="primary"
                plain
                @click="openEditor(row)"
              >
                编辑
              </el-button>
              <el-button
                v-if="$store.getters.isSuperAdmin"
                size="mini"
                type="warning"
                plain
                @click="toggleStatus(row)"
              >
                {{ Number(row.status) === 1 ? "禁用" : "启用" }}
              </el-button>
              <el-button
                v-if="$store.getters.isSuperAdmin"
                size="mini"
                type="danger"
                plain
                @click="removeApp(row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </tableComponents>

    <el-dialog
      :title="editorMode === 'edit' ? '编辑 APP' : '新增 APP'"
      :visible.sync="editorVisible"
      width="860px"
      @closed="resetEditor"
    >
      <el-form
        ref="appFormRef"
        :model="editorForm"
        :rules="editorRules"
        label-width="110px"
      >
        <div class="dialog-section">
          <div class="dialog-section__title">基础信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="应用名称" prop="app_name">
                <el-input
                  v-model.trim="editorForm.app_name"
                  placeholder="请输入应用名称"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="应用编码" prop="app_code">
                <el-input
                  v-model.trim="editorForm.app_code"
                  :disabled="editorMode === 'edit'"
                  placeholder="请输入 app_code"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="包名">
                <el-input
                  v-model.trim="editorForm.package_name"
                  placeholder="请输入 package_name"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态" prop="status">
                <el-switch
                  v-model="editorForm.status"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="启用"
                  inactive-text="禁用"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input
                  v-model.trim="editorForm.remark"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入备注信息"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="dialog-section">
          <div class="dialog-section__title">初始化配置</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="微信 Secret">
                <el-input v-model.trim="editorForm.wx_appSecret" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="微信 AppId">
                <el-input v-model.trim="editorForm.wx_appid" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="版本号">
                <el-input v-model.trim="editorForm.version" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="奖励比例">
                <el-input v-model.trim="editorForm.amount_number" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="APK 地址">
                <el-input v-model.trim="editorForm.apk_url" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="安全密钥">
                <el-input v-model.trim="editorForm.appSecurityKey" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="信息流ID">
                <el-input v-model.trim="editorForm.info_id" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="插屏ID">
                <el-input v-model.trim="editorForm.interstitial_id" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开屏ID">
                <el-input v-model.trim="editorForm.splash_id" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="激励ID">
                <el-input v-model.trim="editorForm.reward_id" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="激励名称">
                <el-input v-model.trim="editorForm.reward_name" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Banner ID">
                <el-input v-model.trim="editorForm.banner_id" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Taku Key">
                <el-input v-model.trim="editorForm.taku_key" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Taku AppId">
                <el-input v-model.trim="editorForm.taku_app_id" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="ECPM Client Key">
                <el-input v-model.trim="editorForm.ecpm_key" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="ECPM Server Key">
                <el-input v-model.trim="editorForm.ecpm_key2" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="马甲包广告">
                <el-switch
                  v-model="editorForm.open_vest_package_ad"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="开启"
                  inactive-text="关闭"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="配置 JSON">
                <el-input
                  v-model.trim="editorForm.app_config_json"
                  type="textarea"
                  :rows="4"
                  placeholder="请输入 app_config_json"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editorVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitEditor">
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const createEditorForm = () => ({
  id: "",
  app_name: "",
  app_code: "",
  package_name: "",
  status: 1,
  remark: "",
  wx_appSecret: "",
  wx_appid: "",
  version: "",
  amount_number: "",
  apk_url: "",
  appSecurityKey: "",
  info_id: "",
  interstitial_id: "",
  splash_id: "",
  reward_id: "",
  reward_name: "",
  banner_id: "",
  taku_key: "",
  taku_app_id: "",
  ecpm_key: "",
  ecpm_key2: "",
  open_vest_package_ad: 0,
  app_config_json: "",
});

export default {
  data() {
    return {
      loading: false,
      saving: false,
      total: 0,
      list: [],
      queryForm: {},
      paginationForm: {
        page: 1,
        page_size: 10,
      },
      editorVisible: false,
      editorMode: "create",
      editorForm: createEditorForm(),
      editorRules: {
        app_name: [
          { required: true, message: "请输入应用名称", trigger: "blur" },
        ],
        app_code: [
          { required: true, message: "请输入应用编码", trigger: "blur" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
    };
  },
  computed: {
    appSearchData() {
      return () => [
        {
          title: "",
          type: "2",
          data: [
            { type: "text", key: "app_name", placeholder: "搜索应用名称" },
            {
              type: "select",
              key: "status",
              placeholder: "状态",
              option: [
                { id: 1, title: "启用" },
                { id: 0, title: "禁用" },
              ],
              onChange: () => {},
            },
          ],
        },
      ];
    },
  },
  methods: {
    getVestPackageStatus(row) {
      const config = row.app_config || {};
      return Number(config.open_vest_package_ad || 0);
    },
    normalizeCreatePayload() {
      return {
        ...this.editorForm,
        status: Number(this.editorForm.status),
        open_vest_package_ad: Number(this.editorForm.open_vest_package_ad),
      };
    },
    normalizeSavePayload() {
      return {
        id: this.editorForm.id,
        app_name: this.editorForm.app_name,
        app_code: this.editorForm.app_code,
        package_name: this.editorForm.package_name,
        status: Number(this.editorForm.status),
        remark: this.editorForm.remark,
      };
    },
    normalizeConfigPayload() {
      return {
        app_id: this.editorForm.id,
        app_code: this.editorForm.app_code,
        wx_appSecret: this.editorForm.wx_appSecret,
        wx_appid: this.editorForm.wx_appid,
        version: this.editorForm.version,
        amount_number: this.editorForm.amount_number,
        apk_url: this.editorForm.apk_url,
        appSecurityKey: this.editorForm.appSecurityKey,
        info_id: this.editorForm.info_id,
        interstitial_id: this.editorForm.interstitial_id,
        splash_id: this.editorForm.splash_id,
        reward_id: this.editorForm.reward_id,
        reward_name: this.editorForm.reward_name,
        banner_id: this.editorForm.banner_id,
        taku_key: this.editorForm.taku_key,
        taku_app_id: this.editorForm.taku_app_id,
        ecpm_key: this.editorForm.ecpm_key,
        ecpm_key2: this.editorForm.ecpm_key2,
        open_vest_package_ad: Number(this.editorForm.open_vest_package_ad),
        app_config_json: this.editorForm.app_config_json,
      };
    },
    async getList() {
      this.loading = true;
      try {
        const data = await this.$api.getApp.getAppList({
          ...this.paginationForm,
          ...this.queryForm,
        });
        this.list = (data.data.list || []).map((item) => ({
          ...item,
          app_config: item.app_config || null,
        }));
        this.total = data.data.count || 0;
      } finally {
        this.loading = false;
      }
    },
    getSearch(form) {
      this.queryForm = form;
      this.paginationForm.page = 1;
      this.getList();
    },
    handleCurrentChange(page) {
      this.paginationForm.page = page;
      this.getList();
    },
    handleSizeChange(size) {
      this.paginationForm.page_size = size;
      this.getList();
    },
    resetEditor() {
      if (this.$refs.appFormRef) {
        this.$refs.appFormRef.resetFields();
      }
      this.editorForm = createEditorForm();
    },
    openEditor(row) {
      this.editorMode = row ? "edit" : "create";
      this.editorVisible = true;

      if (!row) {
        return;
      }

      const config = row.app_config || {};
      this.editorForm = {
        id: row.id,
        app_name: row.app_name || "",
        app_code: row.app_code || "",
        package_name: row.package_name || "",
        status: Number(row.status ?? 1),
        remark: row.remark || "",
        wx_appSecret: config.wx_appSecret || "",
        wx_appid: config.wx_appid || "",
        version: config.version || "",
        amount_number: config.amount_number || "",
        apk_url: config.apk_url || "",
        appSecurityKey: config.appSecurityKey || "",
        info_id: config.info_id || "",
        interstitial_id: config.interstitial_id || "",
        splash_id: config.splash_id || "",
        reward_id: config.reward_id || "",
        reward_name: config.reward_name || "",
        banner_id: config.banner_id || "",
        taku_key: config.taku_key || "",
        taku_app_id: config.taku_app_id || "",
        ecpm_key: config.ecpm_key || "",
        ecpm_key2: config.ecpm_key2 || "",
        open_vest_package_ad: Number(config.open_vest_package_ad || 0),
        app_config_json: config.app_config_json || "",
      };
    },
    async submitEditor() {
      const valid = await new Promise((resolve) => {
        this.$refs.appFormRef.validate((result) => resolve(result));
      });
      if (!valid) {
        return;
      }

      this.saving = true;
      try {
        let data = null;
        if (this.editorMode === "edit") {
          data = await this.$api.getApp.postSaveAppInfo(
            this.normalizeSavePayload()
          );
          if (data.code === 200) {
            await this.$api.getApp.postSaveAppConfig(
              this.normalizeConfigPayload()
            );
          }
        } else {
          data = await this.$api.getApp.postAddApp(
            this.normalizeCreatePayload()
          );
        }

        if (data.code === 200) {
          this.$message.success(
            this.editorMode === "edit" ? "修改成功" : "新增成功"
          );
          this.editorVisible = false;
          this.getList();
          this.$store.dispatch("getAppList");
        }
      } finally {
        this.saving = false;
      }
    },
    async toggleStatus(row) {
      const nextStatus = Number(row.status) === 1 ? 0 : 1;
      const data = await this.$api.getApp.postSaveAppStatus({
        id: row.id,
        status: nextStatus,
      });
      if (data.code === 200) {
        this.$message.success("状态更新成功");
        this.getList();
        this.$store.dispatch("getAppList");
      }
    },
    goDetail(id) {
      this.$router.push({
        path: "/index/app_detail",
        query: { id },
      });
    },
    removeApp(row) {
      this.$confirm(
        `确认删除 APP ${row.app_name || row.app_code} 吗？`,
        "删除确认",
        {
          type: "warning",
        }
      ).then(async () => {
        const data = await this.$api.getApp.postDeleteApp({ id: row.id });
        if (data.code === 200) {
          this.$message.success("删除成功");
          this.getList();
          this.$store.dispatch("getAppList");
        }
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.app-main__title {
  font-weight: 600;
  color: #203864;
}

.app-main__sub {
  margin-top: 4px;
  color: #8090ac;
  font-size: 12px;
}

.bootstrap-summary {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.bootstrap-summary__sub {
  color: #7f8ca6;
  font-size: 12px;
  word-break: break-all;
}

.dialog-section {
  & + & {
    margin-top: 18px;
    padding-top: 18px;
    border-top: 1px dashed #d9e4f3;
  }
}

.dialog-section__title {
  margin-bottom: 14px;
  font-size: 15px;
  font-weight: 600;
  color: #1f4ea0;
}
</style>
